export default "__VITE_ASSET__BtoN2$1T__"